import React from 'react';
import Const from 'constants';
import {CorrelationStackedTeamsListComponent} from 'components/organisms/correlation-stacked-teams-list';
import {KeyPlayerCombinationsComponent} from 'components/organisms/key-player-combinations';
import {UsedPlayersListComponent} from 'components/organisms/used-players-list';
import {ExposureTabsComponent} from 'components/molecules/exposure-tabs';
import {TeamsCombinationsComponent} from 'components/organisms/teams-combinations';
import {StackSummaryComponent} from 'components/organisms/stack-summary';
import {UsedTeamsComponent} from 'components/organisms/used-teams';
import {UsedTeamsComponent as MobileUsedTeamsComponent} from 'components/organisms/used-teams/mobile';
import {UsedPlayersListComponent as MobileUsedPlayersListComponent} from 'components/organisms/used-players-list/mobile';
import {StackSummaryComponent as MobileStackSummaryComponent} from 'components/organisms/stack-summary/mobile';
import {TeamsCombinationsComponent as MobileTeamsCombinationsComponent} from 'components/organisms/teams-combinations/mobile';
import {CorrelationStackedTeamsListComponent as MobileCorrelationStackedTeamsListComponent} from 'components/organisms/correlation-stacked-teams-list/mobile';
import {KeyPlayerCombinationsComponent as MobileKeyPlayerCombinationsComponent} from 'components/organisms/key-player-combinations/mobile';

const Factory = {
    getDesktopComponent(sportConfig) {
        if (sportConfig.isSportNfl()) {
            return (
                <div className="results-aside">
                    <ExposureTabsComponent />
                    <UsedPlayersListComponent />
                    <CorrelationStackedTeamsListComponent />
                    <KeyPlayerCombinationsComponent />
                </div>
            );
        } else if (inArray(sportConfig.getSport(), [Const.LEAGUE_MLB, Const.LEAGUE_LOL, Const.LEAGUE_NHL])) {
            return (
                <div className="results-aside">
                    <ExposureTabsComponent />
                    <UsedPlayersListComponent />
                    <UsedTeamsComponent />
                    <StackSummaryComponent />
                    <TeamsCombinationsComponent />
                </div>
            );
        }

        return (
            <div className="results-aside">
                <UsedPlayersListComponent />
            </div>
        );
    },
    getMobileComponent(sportConfig) {
        if (sportConfig.isSportNfl()) {
            return (
                <div>
                    <ExposureTabsComponent className={'results-aside'} />
                    <MobileUsedPlayersListComponent />
                    <MobileCorrelationStackedTeamsListComponent />
                    <MobileKeyPlayerCombinationsComponent />
                </div>
            );
        } else if (inArray(sportConfig.getSport(), [Const.LEAGUE_MLB, Const.LEAGUE_LOL, Const.LEAGUE_NHL])) {
            return (
                <div>
                    <ExposureTabsComponent className={'results-aside'} />
                    <MobileUsedPlayersListComponent />
                    <MobileUsedTeamsComponent />
                    <MobileStackSummaryComponent />
                    <MobileTeamsCombinationsComponent />
                </div>
            );
        }

        return (
            <div>
                <MobileUsedPlayersListComponent />
            </div>
        );
    },
};

export {Factory};
